export default "__VITE_ASSET__0bfe46ec__"